import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Ellipse,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Ellipse, { cx: "12", cy: "5", rx: "9", ry: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 5v14c0 1.4 3 2.7 7 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12c0 1.2 2 2.5 5 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 5v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v4h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "DatabaseBackup";
const DatabaseBackup = memo(themed(Icon));
export {
  DatabaseBackup
};
//# sourceMappingURL=database-backup.js.map
